import Navigation from './NavigationComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getClientColor } from 'actions/ui/init/initSelectors';
import { setClientUi } from 'actions/ui/init/initActions';
import { action as toggleMenu } from 'redux-burger-menu';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  color: getClientColor(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setClientUi,
      toggleMenu
    },
    dispatch
  );
};

// Create higher-order component which feeds in specified props.
const NavigationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation);

export default NavigationContainer;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/NavigationContainer.js